/**
 * Created by chachora on 11/28/18.
 */
import { createStore, applyMiddleware, Dispatch, AnyAction } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { reducers, RootState } from './reducers';
import { errorMiddleware } from './error.middleware';

export const RESET_APP_STATE = 'RESET_APP_STATE';

export const resetAppState = (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch({ type: RESET_APP_STATE });
  } catch (err) {
    throw err;
  }
};

export default createStore(
  (state: RootState | undefined, action: AnyAction) => {
    if (action.type === RESET_APP_STATE) {
      return reducers(undefined, action);
    }
    return reducers(state, action);
  },
  composeWithDevTools(applyMiddleware(errorMiddleware, thunk))
);
